import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Header from "../common/header";
import TextSection from "../common/text-section";
import NewsletterBegrower from "../common/newsletter/newsletter-begrower";
import Body from "../common/body";
import Text from "../common/text";
import Social from "../common/social";
import Clients from "./clients";
import Gutter from "../common/gutter";
import ContactForm from '../contact/contact-form';

const Footer = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column-reverse;
  }
`;

const FooterSection = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 60px;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 30px;
    margin-bottom: 30px;
    height: auto;
  }
`;

const IntroductionText = styled.div`
  margin-bottom: 40px;
  font-family: "Libre Baskerville", serif;
  font-size: 1rem;
  line-height: 1.5;
  
  & * {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
`;


const Begrower = ({
  socials,
  socialTitle,
  address,
  email,
  title,
  subtitle,
  content,
  clients,
  contactFormIntroduction,
}) => (
  <Body>
    <Header />
    <Gutter size={64} />
    <TextSection title={title} subtitle={subtitle}>
      {content}
    </TextSection>

    <Gutter size={32} />

    <Clients logos={clients} />
    
    <Gutter size={32} />

    {contactFormIntroduction && (
      <>
        <Gutter size={32} />
        <IntroductionText dangerouslySetInnerHTML={{ __html: contactFormIntroduction }} />
      </>
    )}
    <ContactForm buttonClassName="contact-form-button" />

    <Footer>
      <FooterSection>
        <Text font="subtitle" size="s">
        </Text>
        <Text
          font="subtitle"
          css={`
            margin-top: 0px;
          `}
        >
          {address.map((line) => (
            <div key={line}>{line}</div>
          ))}
        </Text>
        <Gutter />
        <Text font="subtitle">
          <a href={`mailto:${email}`}>{email}</a>
        </Text>
            <div>
          <Text
            font="subtitle"
            size="s"
            css={`
              margin-top: 40px;
              margin-bottom: 8px;
              display: block;
            `}
          >
            {socialTitle}
          </Text>
          <Social socials={socials} />
        </div>

      </FooterSection>
      <FooterSection>
        <NewsletterBegrower />
        
        <Gutter />
      </FooterSection>
    </Footer>
  </Body>
);

Begrower.propTypes = {
  socials: Social.propTypes.socials,
  socialTitle: PropTypes.string,
  address: PropTypes.arrayOf(PropTypes.string.isRequired),
  email: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
  clients: Clients.propTypes.logos,
  contactFormIntroduction: PropTypes.string,
};

export default Begrower; 